"use client";

import { c as _c } from "react/compiler-runtime";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import type { PlpFilterValueConfig } from "@/lib/contentful/filterGroups";
import { cn } from "@/lib/utils";
interface RefinementItem {
  value: string;
  count: number;
  isRefined: boolean;
}
interface Props {
  attribute: string;
  items: RefinementItem[];
  values: PlpFilterValueConfig[];
  refine: (value: string) => void;
}

// The live facet response drops values other refinements narrow to zero hits.
// Re-add every known value at count 0 so it renders disabled instead of vanishing.
function withKnownValues(items: RefinementItem[], values: PlpFilterValueConfig[]): RefinementItem[] {
  const present = new Set(items.map(item => item.value));
  const missing = values.filter(value => !present.has(value.productAttributeKey)).map(value => ({
    value: value.productAttributeKey,
    count: 0,
    isRefined: false
  }));
  return [...items, ...missing];
}

// Count desc, label asc tiebreak. Used for dynamic filter groups (e.g. Materials)
// whose values come directly from the Typesense facet response — there's no
// canonical Contentful list to drive a stable order, so we sort by relevance.
function sortItems(items: RefinementItem[]): RefinementItem[] {
  return items.slice().sort((left, right) => {
    if (left.count !== right.count) return right.count - left.count;
    return left.value.localeCompare(right.value);
  });
}
function toInputId(attribute: string, value: string, index: number): string {
  const slug = value.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  return `plp-${attribute}-${slug || `value-${index + 1}`}`;
}
export function PlpRefinementListDynamic(t0) {
  const $ = _c(12);
  const {
    attribute,
    items,
    values,
    refine
  } = t0;
  let t1;
  let t2;
  if ($[0] !== attribute || $[1] !== items || $[2] !== refine || $[3] !== values) {
    const sorted = sortItems(withKnownValues(items, values));
    t1 = "flex flex-col gap-2";
    let t3;
    if ($[6] !== attribute || $[7] !== refine) {
      t3 = (item, index) => {
        const inputId = toInputId(attribute, item.value, index);
        const checked = item.isRefined;
        const disabled = !checked && item.count === 0;
        const handleToggle = function handleToggle() {
          if (disabled) {
            return;
          }
          refine(item.value);
        };
        return <div key={item.value} className="flex items-center gap-2"><Checkbox id={inputId} aria-label={item.value} checked={checked} disabled={disabled} aria-disabled={disabled ? "true" : undefined} onCheckedChange={disabled ? undefined : handleToggle} /><Label htmlFor={inputId} className={cn("flex-1 cursor-pointer text-sm font-medium", disabled && "text-muted-foreground opacity-50 cursor-not-allowed")}>{item.value}</Label><span className={cn("text-sm text-muted-foreground", disabled && "opacity-50")}>({item.count})</span></div>;
      };
      $[6] = attribute;
      $[7] = refine;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = sorted.map(t3);
    $[0] = attribute;
    $[1] = items;
    $[2] = refine;
    $[3] = values;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}